import { lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { StageAuth } from "@/store/AuthStore";

import { PATHS } from "../path";
import { ProtectedRoute } from "../ProtectedRoute";

const OnboardingPage = lazy(
  () => import("@/modules/OnboardingPage/OnboardingPage")
);
const OnboardingApproval = lazy(
  () => import("@/modules/OnboardingPage/OnboardingApproval")
);
const OnboardingPreaaproved = lazy(
  () => import("@/modules/OnboardingPage/PreapprovedOnboarding")
);
const GroupInformationPage = lazy(
  () => import("@/modules/GroupInformationPageOnboarding/GroupInformationPage")
);
const SavedSuccessfully = lazy(
  () => import("@/modules/GroupInformationPageOnboarding/SavedSuccessfully")
);
const CreateDishPageOnboarding = lazy(
  () => import("@/modules/CreateDishPageOnboarding/CreateDishPageOnboarding")
);
const CreateBrandPagesOnboarding = lazy(
  () => import("@/modules/OnboardingPage/BrandStepsOnboarding")
);
const CreateBranchPageOnboarding = lazy(
  () => import("@/modules/OnboardingPage/BranchStepsOnboarding")
);

const withOnboarding = (element: React.ReactNode) => (
  <ProtectedRoute requiredStage={StageAuth.ONBOARDING}>
    {element}
  </ProtectedRoute>
);

const brandSteps = [
  PATHS.ONBOARDING.CREATE_BRAND.DETAILS(":id"),
  PATHS.ONBOARDING.CREATE_BRAND.MENU(":id"),
  PATHS.ONBOARDING.CREATE_BRAND.CONTACTS(":id"),
  PATHS.ONBOARDING.CREATE_BRAND.BRANCHES(":id"),
].map(path => ({
  path,
  element: withOnboarding(<CreateBrandPagesOnboarding />),
}));

const brandDishStep = {
  path: PATHS.ONBOARDING.CREATE_BRAND.NEW_DISH(":id"),
  element: withOnboarding(<CreateDishPageOnboarding />),
};

const brandRedirect = {
  path: PATHS.ONBOARDING.CREATE_BRAND.ROOT(":id"),
  element: (
    <Navigate to={PATHS.ONBOARDING.CREATE_BRAND.DETAILS(":id")} replace />
  ),
};

const branchSteps = [
  PATHS.ONBOARDING.CREATE_BRANCH.DETAILS(":id"),
  PATHS.ONBOARDING.CREATE_BRANCH.HOURS(":id"),
  PATHS.ONBOARDING.CREATE_BRANCH.VIBES(":id"),
  PATHS.ONBOARDING.CREATE_BRANCH.AMENITIES(":id"),
  PATHS.ONBOARDING.CREATE_BRANCH.MEDIA(":id"),
].map(path => ({
  path,
  element: withOnboarding(<CreateBranchPageOnboarding />),
}));

const branchRedirect = {
  path: PATHS.ONBOARDING.CREATE_BRANCH.ROOT(":id"),
  element: (
    <Navigate to={PATHS.ONBOARDING.CREATE_BRANCH.DETAILS(":id")} replace />
  ),
};

export const onboardingRoutes = [
  {
    path: PATHS.ONBOARDING.ROOT,
    element: withOnboarding(<Outlet />),
    children: [
      {
        index: true,
        element: <Navigate to={PATHS.ONBOARDING.PROFILE} replace />,
      },
      {
        path: PATHS.ONBOARDING.PROFILE,
        element: withOnboarding(<OnboardingPage />),
      },
      {
        path: PATHS.ONBOARDING.RESTAURANT_GROUP_INFO,
        element: withOnboarding(<OnboardingPage />),
      },
      {
        path: PATHS.ONBOARDING.PREAPPROVED,
        element: withOnboarding(<OnboardingPreaaproved />),
      },
      {
        path: PATHS.ONBOARDING.WAITING,
        element: withOnboarding(<OnboardingApproval />),
      },
      {
        path: PATHS.ONBOARDING.GROUP_INFO,
        element: withOnboarding(<GroupInformationPage />),
      },
      {
        path: PATHS.ONBOARDING.SAVED,
        element: withOnboarding(<SavedSuccessfully />),
      },

      brandRedirect,
      ...brandSteps,
      brandDishStep,

      branchRedirect,
      ...branchSteps,
    ],
  },
];
